<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-reward_reached-description') }}
        </p>
    </div>
</template>
<script>
export default {
    template: "#automations-triggers-reward-reached-template",
    data: function () {
        return {};
    },
    mounted: function () {
        this.changed();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("input", [{}]);
        },
        isValid: function () {
            return true;
        },
    },
};
</script>
